import {
  SUPERSET_CSAT_RESPONSE_RATE,
  SUPERSET_CSAT_RESPONSE_RATE_SUCCESS,
  SUPERSET_CSAT_RESPONSE_RATE_ERROR,
  SUPERSET_CSAT_RESPONSE_RATE_EMPTY,
} from '../../../../actionType';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const SupersetCsatResponseRate = (state = initialState, action) => {
  switch (action.type) {
    case SUPERSET_CSAT_RESPONSE_RATE:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case SUPERSET_CSAT_RESPONSE_RATE_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case SUPERSET_CSAT_RESPONSE_RATE_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case SUPERSET_CSAT_RESPONSE_RATE_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default SupersetCsatResponseRate;
